import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services';
import { UsersService } from './../services/users.service';
import { User } from '../models/user.model';
import { Subscription } from 'rxjs/Subscription';
import { InsuredNotificationService } from 'app/shared-model/services/insuredNotificationService';
import { NotificationRefreshService } from '../services/notificationRefreshService';
import { NotificationTypeEnum } from 'app/shared-model/model/enums/NotificationTypeEnum';

@Component({
  selector: 'core-current-user',
  templateUrl: './current-user.component.html',
  styleUrls: ['./current-user.component.css']
})
export class CurrentUserComponent implements OnInit, OnDestroy {
  user: User;
  showUserInfo = false;
  notificationCount: number = 0;
  thirdPartyPreloadCount: number = 0;
  hasNotificationsRole = false;
  public isLoggedIn: boolean;
  private subscriptions: Subscription[] = [];
  @Output() messageEvent = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    private usersService: UsersService,
    private authenticationService: AuthenticationService,
    private insuredNotificationService: InsuredNotificationService,
    private notificationRefreshService: NotificationRefreshService) {
  }

  ngOnInit() {
    this.subscriptions.push(this.authenticationService.loginNotifier.subscribe(result => {
      if (result) {
        this.usersService.currentUser.subscribe(user => {
          this.user = user;
          this.hasNotificationsRole = !!(user && user.roles && user.roles.some(r => r.name === 'NotificacionesRol'));
          this.isLoggedIn = result;
          this.messageEvent.emit(this.isLoggedIn);
          this.searchNotifications();
        });
      }
    }));

    this.subscriptions.push(
      this.notificationRefreshService.refresh$.subscribe(() => {
        this.searchNotifications();
      })
    );


  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  toggleShowInfo() {
    this.showUserInfo = !this.showUserInfo;
  }

  redirectToNotifications() {
    this.router.navigate(['notification'], { queryParams: {} });
  }

  redirectToThirdPartyPreloads() {
    this.router.navigate(['notification'], { queryParams: { type: NotificationTypeEnum.PrecargaTerceroWeb } });
  }

  logout() {
    this.isLoggedIn = false;
    this.messageEvent.emit(this.isLoggedIn)
    this.toggleShowInfo();
    this.authenticationService.logout();
    this.user = null;
    this.router.navigate(['login'], { queryParams: {} });
  }

  public searchNotifications(): void {
    if (!this.hasNotificationsRole) {
      this.notificationCount = 0;
      this.thirdPartyPreloadCount = 0;
      return;
    }

    this.subscriptions.push(
      this.insuredNotificationService.count().subscribe((q) => {
        this.notificationCount = q;
        console.log(this.notificationCount);
      })
    );
    this.subscriptions.push(
      this.insuredNotificationService.count(NotificationTypeEnum.PrecargaTerceroWeb).subscribe((q) => {
        this.thirdPartyPreloadCount = q;
      })
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/current-user/current-user.component.ts